export const getShippingDates = (packages) => {
  const min = packages.map((p) => p.deliveryDate.min).sort();
  const max = packages.map((p) => p.deliveryDate.max).sort();
  return [min?.[0] || null, max?.[max.length - 1] || null];
};
